import { render, staticRenderFns } from "./app-sidebar.vue?vue&type=template&id=e2a7bde6&scoped=true&"
import script from "./app-sidebar.vue?vue&type=script&lang=js&"
export * from "./app-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a7bde6",
  null
  
)

export default component.exports